import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IntegrationInstructionsOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useGetAssociatedRunnerFromType } from '../../../../../../state/hooks/DatastoreHooks';
import { FadingTooltip } from '../../../../../../ui';
import { useDownloadRunLogs } from './DownloadLogsButtonHooks';

export const DownloadLogsButton = ({ runnerName }) => {
  const { t } = useTranslation();
  const downloadRunLogs = useDownloadRunLogs();
  const getAssociatedRunnerFromType = useGetAssociatedRunnerFromType();
  const runner = useMemo(() => getAssociatedRunnerFromType(runnerName), [runnerName, getAssociatedRunnerFromType]);
  const handleDownloadLogs = useCallback(
    () => downloadRunLogs(runner?.id, runner?.lastRunId),
    [runner, downloadRunLogs]
  );

  const logLabel =
    runnerName === 'validation'
      ? t('commoncomponents.datastore.download.logs.validation', '(debug) Verification logs')
      : t('commoncomponents.datastore.download.logs.push', '(debug) Dataset creation logs');

  return (
    <FadingTooltip title={logLabel}>
      <IconButton color="primary" onClick={handleDownloadLogs} disabled={!runner?.id || !runner?.lastRunId}>
        <IntegrationInstructionsOutlined fontSize="large" />
      </IconButton>
    </FadingTooltip>
  );
};

DownloadLogsButton.propTypes = {
  runnerName: PropTypes.string,
};
